<template lang="pug">
  .notification.width-100.pointer(@click='showDetail')
    .header.row.middle
      simple-svg.m-right-1(:filepath='getTagIcon(notification.tag)' width='18px' height='18px')
      h2.text-normal.uppercase {{ getTagTitle(notification.tag) }}
      button.m-left-auto(v-if='withDetail' @click='showNotificationModal')
        simple-svg(:filepath='fullscreenIcon' width='16px' height='16px')
    .short.row.m-bottom-05
      .column.item-1
        .title.row.middle.m-bottom-05
          h2.text-normal.blue.bold {{ notification.title }}
            span.date.m-left-1.text-small.dark-gray {{ notification.date }}
        p.description.text-normal.dark-gray {{ notification.brief }}
      button(@click='showDetail' v-if='!withDetail')
        simple-svg(:filepath='arrowRight' width='18px' height='18px')
    .detail.md-content.md-small(v-if='withDetail' v-html='notification.detail')
    .row.end
      h3.text-normal.gray {{ formatDate(notification.startDate) }}
</template>

<script>
import calendarIcon from '@/assets/ic_calendar.svg'
import { notificationsTags, notificationsTagsIcons } from '../../constants/notifications'
import { i18n } from '../../main'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import arrowRight from '@/assets/ic_chevron-right.svg'
import fullscreenIcon from '@/assets/tiptap/fullscreen.svg'
import { localesToMoment } from '../../constants/languages'

export default {
  props: {
    notification: { type: Object },
    forModal: { type: Boolean },
    withDetail: { type: Boolean }
  },
  data() {
    return {
      calendarIcon,
      fullscreenIcon,
      arrowRight
    }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    })
  },
  methods: {
    ...mapActions([
      'hideElement',
      'showElement'
    ]),
    getTagTitle(not) {
      const tag = Object.keys(notificationsTags).find(key => notificationsTags[key] === not)
      return i18n.t(`notifications.tags.${tag}`)
    },
    getTagIcon(not) {
      return notificationsTagsIcons[not]
    },
    showDetail() {
      this.$emit('showDetail', this.notification)
    },
    formatDate(date) {
      return moment(date).locale(localesToMoment[this.locale]).format('LL')
    },
    showNotificationModal() {
      this.hideElement({ element: 'notificationsDrawer' })
      this.showElement({
        element: 'notificationModal',
        props: { notification: this.notification }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.notification{
  background-color: $white;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0px 4px 4px $shadow-gray2;
  .header{
    border-bottom: 1px solid $light-gray;
    padding-bottom: 6px;
    margin-bottom: 15px;
  }
}

.detail{
  &>*{
    width: 100%;
    max-width: 100%;
  }
  img{
    width: 100%;
    max-width: 100%;
    object-fit: contain;
  }
}
</style>
